import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/coffee-paste.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0e31a0ca")

_pushScopeId("data-v-0e31a0ca")
const _hoisted_1 = { class: "login-page-container" }
const _hoisted_2 = { class: "login-card-container" }
const _hoisted_3 = { class: "login-container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  alt: "coffee paste lopg",
  src: _imports_0
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Coffee-Paste ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Welcome to the Coffee-Paste workspace. ")
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" The web-based notepad++ like, but with muscles 😎 ")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ☕ IN DEVELOPMENT ☕ ")
const _hoisted_12 = { class: "login-providers-container" }
const _hoisted_13 = {
  key: 0,
  class: "login-loader-container"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "login-provider-container" }
const _hoisted_16 = { class: "login-provider-icon-container" }
const _hoisted_17 = { class: "p-ml-2 p-text-bold login-provider-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Card, null, {
          header: _withId(() => [
            _hoisted_4
          ]),
          title: _withId(() => [
            _hoisted_5
          ]),
          content: _withId(() => [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11
          ]),
          footer: _withId(() => [
            _createVNode("div", _hoisted_12, [
              (_ctx.isLogedon)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode(_component_ProgressSpinner)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_14, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.providers, (provider) => {
                      return (_openBlock(), _createBlock("div", {
                        key: provider.provider
                      }, [
                        _createVNode("div", _hoisted_15, [
                          _createVNode(_component_Button, {
                            onClick: ($event: any) => (_ctx.login(provider)),
                            type: "button",
                            label: "Primary",
                            class: "p-button-outlined p-button-lg login-button"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_16, [
                                _createVNode("img", {
                                  alt: "logo",
                                  src: provider.icon,
                                  style: {"width":"1.4rem"}
                                }, null, 8, ["src"])
                              ]),
                              _createVNode("span", _hoisted_17, "Login with " + _toDisplayString(provider.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
})